import { combineReducers } from "redux";
import { intlReducer } from "react-intl-redux";
import { connectRouter } from "connected-react-router";

import conciliated from "./conciliated";
import pending from "./pending";
import user from "./user";
import files from "./files";
import clients from "./clients";
import messages from "./messajes";
import automatic from "./automatic";
import detail from "./detail";

export default history =>
  combineReducers({
    intl: intlReducer,
    router: connectRouter(history),
    conciliated,
    pending,
    user,
    files,
    clients,
    messages,
    automatic,
    detail
  });
